import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Button,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Tooltip,
  InputAdornment
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";

import { isMobile } from "react-device-detect";
import { Image, Table } from "antd";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getProducts, getWarehouses, downloadInboundsQRS, getVendors } from "../../app/store/actions/imsWarehouseStaffActions";
import { useEffect } from "react";
import { AddCircleOutline, DownloadOutlined, Search } from "@mui/icons-material";
import moment from "moment/moment";
import InboundsTable from "../../app/components/InboundsTable";

export const InboundsList = ({
  getProducts,
  getWarehouses,
  downloadInboundsQRS,
  getVendors,
  user,
  vendors,
  warehouses,
  products,
  isLoading
}) => {
  const navigate = useNavigate();
  const [selectedInboundItems, setSelectedInboundItems] = React.useState([]);
  const [copies, setCopies] = React.useState(1);
  const [warehouseId, setWarehouseId] = React.useState(null);
  const [vendorId, setVendorId] = React.useState(null);
  const [page, setPage] = React.useState(1);
  const [search, setSearch] = React.useState('');
  const [appliedSearch, setAppliedSearch] = React.useState('');

  const getInboundsParams = (targetPage = page) => ({
    page: targetPage,
    limit: 100,
    warehouseId,
    vendorId,
    hasInbounds: true,
    search: appliedSearch || undefined,
  });

  const handleSearch = () => {
    setAppliedSearch(search.trim());
    if (page !== 1) {
      setPage(1);
    }
    setSelectedInboundItems([]);
  };

  useEffect(() => {
    getProducts(getInboundsParams())
  }, [page, appliedSearch])

  useEffect(() => {
    if(page === 1){
      getProducts(getInboundsParams(1))
    } else {
      setPage(1)
    }
  }, [warehouseId, vendorId])

  useEffect(() => {
    getWarehouses({ page: 1, limit: 100 })
    getVendors({ page: 1, limit: 1000 })
  }, [])

  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedInboundItems(newSelectedRowKeys.map((key) => { return key }));
  };

  const rowSelection = {
    selectedInboundItems,
    onChange: onSelectChange,
  };

  const handlePrintSelected = () => {
    const data = products?.docs?.filter((row) => { return selectedInboundItems.includes(row._id) }).map((row) => {
      return {
        inbound: row.inbound,
        inboundItem: {
          ...row,
          quantity: copies
        },
        product: row.product,
        vendor: row.inbound.vendor,
      }
    })

    downloadInboundsQRS({ items: data })
  }

  const handlePrintAllSelected = () => {
    const data = products?.docs?.filter((row) => { return selectedInboundItems.includes(row._id) }).map((row) => {
      return {
        inbound: row.inbound,
        inboundItem: row,
        product: row.product,
        vendor: row.inbound.vendor,
      }
    })

    downloadInboundsQRS({ items: data })
  }


  const handlePrintAllCopies = () => {
    const data = products?.docs?.map((row) => {
      return {
        inbound: row.inbound,
        inboundItem: {
          ...row,
          quantity: copies
        },
        product: row.product,
        vendor: row.inbound.vendor,
      }
    })

    downloadInboundsQRS({ items: data })
  }


  const handlePrintAll = () => {
    const data = products?.docs?.map((row) => {
      return {
        inbound: row.inbound,
        inboundItem: row,
        product: row.product,
        vendor: row.inbound.vendor,
      }
    })

    downloadInboundsQRS({ items: data })
  }


  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Inbounds</Typography>
          <Tooltip title="Download all pieces"><IconButton onClick={handlePrintAll} sx={{ color: "var(--secColor)", mx: 2 }}><DownloadOutlined /></IconButton></Tooltip>
        </Box>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Box sx={{ ...left_flex_box }}>
                <BrandSelect
                  vendors={vendors}
                  value={vendorId}
                  label="Filter by Vendor"
                  emptyLabel="All vendors"
                  autoFocus
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  onChange={(id) => setVendorId(id)}
                />
                <MainInput
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  margin="normal"
                  label="Search"
                  placeholder="SKU or inbound ID"
                  value={search}
                  onChange={({ target }) => setSearch(target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleSearch} edge="end" sx={{ color: "var(--secColor4)" }}>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box sx={{ ...left_flex_box }}>
                <MainInput
                  select
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  defaultValue={warehouseId}
                  label="Warehouse"
                  onChange={({ target }) => setWarehouseId((target.value))}
                >
                  {warehouses?.map((warehouse) => <MenuItem value={warehouse._id}>{warehouse.name}</MenuItem>)}
                </MainInput>
                <Button onClick={() => navigate(`/ims/admin/inbounds/receive/${warehouseId}`)} disabled={warehouseId === null || isLoading} sx={{ ...main_button }}>{isLoading ? <CircularProgress color="white" /> : "Receive Items"}</Button>
              </Box>
            </CardContent>
            <CardContent>
              <Box sx={{ ...left_flex_box }}>
                <MainInput
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  defaultValue={copies}
                  label="Copies to Print"
                  onChange={({ target }) => setCopies((target.value))}
                  type="number"
                  inputProps={{
                    min: 1
                  }}
                />
                <Button onClick={() => handlePrintSelected()} disabled={selectedInboundItems.length === 0 || isLoading} sx={{ ...main_button, mr: 1 }}>{isLoading ? <CircularProgress color="white" /> : `Print ${copies} copies of selected items`}</Button>
                <Button onClick={() => handlePrintAllCopies()} disabled={isLoading} sx={{ ...main_button, mr: 1 }}>{isLoading ? <CircularProgress color="white" /> : `Print ${copies} copies of all items`}</Button>
                <Button onClick={() => handlePrintAllSelected()} disabled={selectedInboundItems.length === 0 || isLoading} sx={{ ...main_button, mr: 1 }}>{isLoading ? <CircularProgress color="white" /> : `Print actual quantities of selected items`}</Button>
              </Box>
              <Typography sx={{ ml: 1 }}>{selectedInboundItems.length > 0 ? `Selected ${selectedInboundItems.length} items` : null}</Typography>
            </CardContent>
          </Card>
        </Box>
        <InboundsTable products={products?.docs} rowSelection={rowSelection} page={page} setPage={setPage} pagination={products} />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  products: state?.records?.productInbounds,
  vendors: state?.records?.vendors,
  warehouses: state?.records?.warehouses?.docs
});

const mapDispatchToProps = { getProducts, getWarehouses, getVendors, downloadInboundsQRS };

export default connect(mapStateToProps, mapDispatchToProps)(InboundsList);
